/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misty_Cuddly_Jellyfish_DashInputs */

const fr_misty_cuddly_jellyfish_dash = /** @type {(inputs: Misty_Cuddly_Jellyfish_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun évenement trouvé pour cette date.`)
};

/**

* @param {Misty_Cuddly_Jellyfish_DashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const misty_cuddly_jellyfish_dash = /** @type {((inputs?: Misty_Cuddly_Jellyfish_DashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misty_Cuddly_Jellyfish_DashInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_misty_cuddly_jellyfish_dash(inputs)
});